import { render, staticRenderFns } from "./Ver.vue?vue&type=template&id=2b6e6a1e&"
import script from "./Ver.vue?vue&type=script&lang=js&"
export * from "./Ver.vue?vue&type=script&lang=js&"
import style0 from "./Ver.vue?vue&type=style&index=0&id=2b6e6a1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports